import axios from 'axios'
import getDeviceHeader from './getDeviceHeader.js'
import { events } from './events.js'

const AuthAxios = axios.create({
  baseURL: import.meta.env.VITE_APP_API_BASE_URL
})

export default {
  async upload(file, installId, appData, scansSessionHint, deviceInfo = null) {
    const headers = {
      'Content-Type': 'multipart/form-data',
      'x-scantrust-install-id': installId,
      'x-scantrust-device': await getDeviceHeader(appData, deviceInfo),
      'x-scantrust-app-version': __APP_VERSION__,
      ...(scansSessionHint
        ? { 'X-Scantrust-Session-Hint': scansSessionHint }
        : {})
    }

    return new Promise((resolve, reject) => {
      let formData = new FormData()

      formData.append('image', file)
      formData.append('location', JSON.stringify(events.value.locationData))

      AuthAxios.post(`scan/photo/`, formData, { headers })
        .then((res) => {
          resolve(res)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
